import { Routes, Route } from "react-router-dom";
import Login from '../pages/Login';

function LoginApp() {
  return (
    <Routes>
      <Route path="/login" element={<Login />}/>
    </Routes>
  )
}

export default LoginApp